import DropdownOptionTemp from "../DropdownOptionTemp";
import { Wrapper } from "./styles";
const FaqTemplate = () => {
  return (
    <DropdownOptionTemp headingText={"FAQs"}>
      <Wrapper>
        <iframe
          width="100%"
          style={{ border: "none", height: "800px" }}
          src={`https://${process.env.REACT_APP_ASSETS_DOMAIN_WITH_ENV}.cnaps.co.in/faq/v1/CNAPS_FAQS.html`}
          title="instructions"
        />
      </Wrapper>
    </DropdownOptionTemp>
  );
};

export default FaqTemplate;
